import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import ReactSelect from 'react-select';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { RequirementType, } from '@debbie/common/dist/workflows/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors.js';
import Checkbox from '../Checkbox.js';
import { X } from '../Icons/index.js';
import Input from '../Input.js';
import SearchInput from '../SearchInput.js';
import Select from '../Select.js';
import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { useCaseGroups } from '@debbie/cortex/dist/caseGroups/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
const RequirementsInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const updateTypes = useSelector(selectUpdateTypes);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : null;
    const { disabled, requirements, onChange } = props;
    return (React.createElement("div", null,
        requirements.map((requirement, i) => (React.createElement(RequirementEditor, { requirement: requirement, requirements: requirements, index: i, onChange: onChange, key: requirement.id, disabled: disabled }))),
        !props.disabled && (React.createElement(Select, { disabled: disabled, value: "", onChange: (e) => {
                const val = e.target.value;
                const updateType = updateTypes && updateTypes[0];
                const creditor = creditors && creditors[0];
                if (Object.values(RequirementType).includes(val) &&
                    updateType) {
                    const type = val;
                    let details = {};
                    switch (type) {
                        case RequirementType.HasUpdate:
                        case RequirementType.DoesNotHaveUpdate:
                            details = {
                                updateTypeId: updateType.updateTypeId,
                            };
                            break;
                        case RequirementType.AmountThreshold:
                            details = {
                                moreThan: true,
                                amount: 100000,
                            };
                            break;
                        case RequirementType.CaseGroup:
                            details = {
                                caseGroupId: caseGroups && caseGroups[0]?.id,
                            };
                            break;
                        case RequirementType.PercentageSplit:
                            details = {
                                from: 0,
                                to: 0.5,
                            };
                            break;
                        case RequirementType.SpecificCreditor:
                            details = {
                                creditorId: creditor?.creditorId || null,
                            };
                            break;
                        case RequirementType.CustomerHasTag:
                            details = {
                                tag: '',
                            };
                            break;
                        default:
                            break;
                    }
                    onChange(requirements.concat({
                        id: crypto.randomUUID(),
                        type,
                        details,
                    }));
                }
            } },
            React.createElement("option", null, lang.workflows.addRequirement),
            Object.values(RequirementType).map((type) => (React.createElement("option", { key: type, value: type }, lang.workflowRequirementTypes[type])))))));
};
const RequirementEditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const updateTypes = useSelector(selectUpdateTypes);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : null;
    const { requirement, requirements, index, onChange } = props;
    const [updateTypeId, setUpdateTypeId] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.updateTypeId);
    const [caseGroupId, setCaseGroupId] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.caseGroupId);
    const [amount, setAmount] = useState(
    // TODO: fix this
    //@ts-ignore
    `${(requirement.details.amount || 0) / 100}`);
    const [percentageSplitFrom, setPercentageSplitFrom] = useState(
    // TODO: fix this
    //@ts-ignore
    `${(requirement.details.from || 0) * 100}`);
    const [percentageSplitTo, setPercentageSplitTo] = useState(requirement.type === RequirementType.PercentageSplit
        ? `${(requirement.details.to || 0) * 100}`
        : null);
    const [creditorId, setCreditorId] = useState(requirement.type === RequirementType.SpecificCreditor
        ? requirement.details.creditorId
        : null);
    const [foundationTypeState, setFoundationTypeState] = useState(requirement.type === RequirementType.HasFoundation &&
        requirement.details.foundationTypes?.length > 0
        ? {
            foundationTypes: requirement.details.foundationTypes,
            onlySelectedFoundationTypes: true,
        }
        : {
            foundationTypes: [],
            onlySelectedFoundationTypes: false,
        });
    const [customerTag, setCustomerTag] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.tag);
    const onRequirementChange = (change) => {
        onChange(requirements.map((_requirement, i) => {
            if (i === index) {
                const _copy = {
                    ..._requirement,
                };
                _copy.details = {
                    ..._requirement.details,
                    ...change,
                };
                return _copy;
            }
            return _requirement;
        }));
    };
    const searchUpdateTypes = (q) => {
        if (!updateTypes)
            return [];
        return updateTypes
            .filter((uT) => {
            return (`${uT.label}${lang.updateTypes[uT.updateTypeId]}`
                .toLocaleLowerCase()
                .indexOf(q.toLocaleLowerCase()) !== -1);
        })
            .map((uT) => ({
            heading: lang.updateTypes[uT.updateTypeId] || uT.label,
            subheading: uT.groupLabel,
            key: uT.updateTypeId,
            returnData: uT,
        }))
            .sort((a, b) => (a.heading > b.heading ? 1 : 0) - (a.heading < b.heading ? 1 : 0));
    };
    const searchAllCaseGroups = (q) => (caseGroups || [])
        .filter((caseGroup) => {
        const query = `${caseGroup.label}`
            .toLocaleLowerCase()
            .indexOf(q.toLocaleLowerCase()) !== -1 || !q;
        return query;
    })
        .map((caseGroup) => ({
        heading: caseGroup.label,
        returnData: caseGroup.id,
        key: caseGroup.id,
    }));
    const searchAllCreditors = (q) => (creditors || [])
        .filter((creditor) => {
        const query = `${creditor.name}`
            .toLocaleLowerCase()
            .indexOf(q.toLocaleLowerCase()) !== -1 || !q;
        return query;
    })
        .map((creditor) => ({
        heading: creditor.name,
        returnData: creditor.creditorId,
        key: creditor.creditorId,
    }));
    const selectedCaseGroup = caseGroupId &&
        caseGroups &&
        caseGroups.find((caseGroup) => caseGroup.id === caseGroupId);
    const selectedCreditor = creditorId &&
        creditors &&
        creditors.find((creditor) => creditor.creditorId === creditorId);
    return (React.createElement(RequirementStyled, null,
        React.createElement("h4", null,
            lang.workflowRequirementTypes[requirement.type],
            ' ',
            !props.disabled && (React.createElement(X, { style: { float: 'right', cursor: 'pointer' }, onClick: () => onChange(requirements.filter((_, i) => index !== i)) }))),
        (() => {
            switch (requirement.type) {
                case RequirementType.HasUpdate:
                case RequirementType.DoesNotHaveUpdate:
                    return (React.createElement(SearchInput, { onSelect: (uT) => {
                            setUpdateTypeId(uT.updateTypeId);
                            onRequirementChange({
                                updateTypeId: uT.updateTypeId,
                            });
                        }, onRemoveStatic: () => {
                            setUpdateTypeId(null);
                        }, forceOpen: true, static: [
                            RequirementType.DoesNotHaveUpdate,
                            RequirementType.HasUpdate,
                        ].includes(requirement.type) && updateTypesMap[updateTypeId]
                            ? lang.updateTypes[updateTypeId] ||
                                (updateTypesMap[updateTypeId] &&
                                    updateTypesMap[updateTypeId].label)
                            : null, searchDelay: 0, searchAll: searchUpdateTypes, placeholder: lang.cases.pauseReason }));
                case RequirementType.AmountThreshold:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.moreThan, checked: requirement.details.moreThan, onChange: (e) => onRequirementChange({
                                moreThan: e.target.checked,
                            }) }),
                        React.createElement(Input, { type: "number", placeholder: lang.workflows.thresholdAmount, value: amount, onChange: (e) => {
                                const val = e.target.value;
                                setAmount(val);
                                const isNumber = !isNaN(parseFloat(val));
                                if (isNumber) {
                                    onRequirementChange({
                                        amount: Math.round(parseFloat(val) * 100),
                                    });
                                }
                            } }),
                        React.createElement(ReactSelect, { value: requirement.details.onlySelectedCategories
                                ? requirement.details.onlySelectedCategories.map((category) => ({
                                    label: (category &&
                                        lang.economyCategories[category]) ||
                                        category,
                                    value: category,
                                }))
                                : [], isMulti: true, placeholder: lang.workflows.onlySelectedVoucherCategories, classNamePrefix: "select", options: [].concat(CaseVoucherCategories.filter((category) => ![VoucherCategory.TRANSACTION].includes(category)).map((category) => ({
                                label: lang.economyCategories[category],
                                value: category,
                            }))), onChange: (val) => {
                                const selectedCategories = val?.length
                                    ? val.map((v) => v.value)
                                    : undefined;
                                onRequirementChange({
                                    onlySelectedCategories: selectedCategories,
                                });
                            } })));
                case RequirementType.CaseGroup:
                    return (React.createElement(SearchInput, { placeholder: lang.workflows.caseGroup, forceOpen: true, static: selectedCaseGroup && selectedCaseGroup.label, onSelect: (caseGroupId) => {
                            setCaseGroupId(caseGroupId);
                            onRequirementChange({
                                caseGroupId,
                            });
                        }, onRemoveStatic: () => setCaseGroupId(null), searchAll: searchAllCaseGroups }));
                case RequirementType.PercentageSplit:
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Input, { type: "number", placeholder: lang.workflows.percentageSplitFrom, value: percentageSplitFrom, onChange: (e) => {
                                const val = e.target.value;
                                setPercentageSplitFrom(val);
                                const isNumber = !isNaN(parseFloat(val));
                                if (isNumber) {
                                    onRequirementChange({
                                        from: parseFloat(val) / 100,
                                    });
                                }
                            } }),
                        React.createElement(Input, { type: "number", placeholder: lang.workflows.percentageSplitTo, value: percentageSplitTo || '', onChange: (e) => {
                                const val = e.target.value;
                                setPercentageSplitTo(val);
                                const isNumber = !isNaN(parseFloat(val));
                                if (isNumber) {
                                    onRequirementChange({
                                        to: parseFloat(val) / 100,
                                    });
                                }
                            } })));
                case RequirementType.SpecificCreditor:
                    return (React.createElement(SearchInput, { placeholder: lang.workflows.selectedCreditor, forceOpen: true, static: selectedCreditor && selectedCreditor.name, onSelect: (creditorId) => {
                            setCreditorId(creditorId);
                            onRequirementChange({
                                creditorId,
                            });
                        }, onRemoveStatic: () => setCreditorId(null), searchAll: searchAllCreditors }));
                case RequirementType.CustomerHasTag:
                    return (React.createElement(SearchInput, { placeholder: "Tag", autofocus: true, searchAll: async (q) => {
                            const tags = await customersAPI.getUsedTags();
                            let res = [];
                            if (tags.length) {
                                res = res.concat(tags
                                    .filter((t) => {
                                    if (!q) {
                                        return true;
                                    }
                                    return t.toLowerCase().includes(q.toLowerCase());
                                })
                                    .map((t) => ({
                                    heading: t,
                                    returnData: t,
                                    key: t,
                                })));
                            }
                            if (q && !res.find((r) => r.returnData === q)) {
                                res = res.concat({
                                    heading: q,
                                    returnData: q,
                                    key: q,
                                });
                            }
                            return res;
                        }, static: customerTag || undefined, onRemoveStatic: () => setCustomerTag(''), onSelect: (t) => {
                            setCustomerTag(t);
                            onRequirementChange({
                                tag: t,
                            });
                        } }));
                case RequirementType.HasFoundation:
                    return (React.createElement("div", null,
                        React.createElement(Checkbox, { placeholder: 'Kun specifikke typer fundamenter', checked: foundationTypeState.onlySelectedFoundationTypes, onChange: (e) => {
                                setFoundationTypeState({
                                    onlySelectedFoundationTypes: e.target.checked,
                                    foundationTypes: e.target.checked
                                        ? foundationTypeState.foundationTypes
                                        : [],
                                });
                                onRequirementChange({
                                    onlySelectedFoundationTypes: e.target.checked,
                                    foundationTypes: e.target.checked ? [] : undefined,
                                });
                            } }),
                        foundationTypeState.onlySelectedFoundationTypes &&
                            [
                                DocumentTypes.DOM,
                                DocumentTypes.GAELDSBREV,
                                DocumentTypes.FOUNDATION,
                                DocumentTypes.SKYLDERKLAERING,
                                DocumentTypes.FORLIG,
                            ].map((documentType) => (React.createElement(Checkbox, { checkMark: true, key: documentType, placeholder: lang.documentTypes[documentType], checked: foundationTypeState.foundationTypes?.includes(documentType), onChange: (e) => {
                                    const foundationTypes = requirement.details.foundationTypes || [];
                                    const changes = e.target.checked
                                        ? foundationTypes.concat(documentType)
                                        : foundationTypes.filter((dt) => dt !== documentType);
                                    setFoundationTypeState({
                                        foundationTypes: changes,
                                        onlySelectedFoundationTypes: changes.length === 0 ? false : true,
                                    });
                                    onRequirementChange({
                                        foundationTypes: changes,
                                        onlySelectedFoundationTypes: changes.length === 0 ? false : true,
                                    });
                                } })))));
                default:
                    return null;
            }
        })()));
};
export default RequirementsInput;
const RequirementStyled = styled.div `
  font-size: 12px;
  background: #e8e8e8;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 3px;

  h4 {
    margin: 7px 0;
  }
`;
//# sourceMappingURL=RequirementsInput.js.map